import { ExitIntentModal } from '../ExitIntentModal';
import { Footer } from '../Footer';
import { Header } from '../Header';
import * as Styled from './Layout.styles';

const Layout = ({ children }) => {
  return (
    <Styled.App>
      <Header />
      <Styled.Main>{children}</Styled.Main>
      <Footer />
      <ExitIntentModal />
    </Styled.App>
  );
};

export default Layout;
